import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import { danfossTheme } from '../../lib/danfossTheme';

const danfossThemeExtension = ThemeBlueprint.make({
  name: 'danfoss',
  params: {
    theme: {
      id: 'danfossTheme',
      title: 'Danfoss Theme',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={danfossTheme} children={children} />
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [danfossThemeExtension],
});
